import { render, staticRenderFns, recyclableRender, components } from "./catering-certification.vue?vue&type=template&id=73c84b74&scoped=true&"
var renderjs
import script from "./catering-certification.vue?vue&type=script&lang=js&"
export * from "./catering-certification.vue?vue&type=script&lang=js&"
import style0 from "./catering-certification.vue?vue&type=style&index=0&lang=css&"
import style1 from "./catering-certification.vue?vue&type=style&index=1&id=73c84b74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c84b74",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/catering-certification/catering-certification.vue"
export default component.exports